import { func } from "joi";
// import { Timeline } from "vue2vis";
// import { DataSet } from 'vue2vis'
// import "vue2vis/dist/vue2vis.css";
import searcher from "@/components/info/searcher.vue"
import dates from "@/components/info/dates.vue"
		
	export default{
		name 		: 'smart_reports',
		// extends: Line,

		components  : {
			searcher,
			dates,
			// Timeline,
			// GChart
			// LineChart,
			// events
		}, // components
		data : (vm) => ({
			objects				:[],
			info 				: {},
			info_search 		: {
				tags : [],
				entity : [],
			},
			info_search_fields 	: [
				{
					key 		: 'search',
					text 		: 'search',
					placeholder : 'device',
					list 		: 'list_devices',
					key_list	: 'deviceId',
					text_list 	: 'name',
					type 		: 'select_searcher',
					key_search  : 'name',
					key_search_1 : 'deviceId',
					visible 	: true,
					cols 		: {
						col : 2,
					},
				},
				{
					key 		: 'dates',
					text 		: 'date',
					placeholder : 'select',
					type 		: 'date_range',
					visible 	: true,
					cols 		: {
						col : 2,
					},
				},
				{
					key 		: 'start',
					menu 		: 'picker_start',
					ref 		: 'menu_start',
					text 		: 'Start',
					placeholder : 'time',
					type 		: 'time_picker',
					visible 	: true,
					cols 		: {
						col : 2,
					},
				},
				{
					key 		: 'end',
					menu 		: 'picker_end',
					ref 		: 'menu_end',
					text 		: 'End',
					placeholder : 'time',
					type 		: 'time_picker',
					visible 	: true,
					cols 		: {
						col : 2,
					},
				},
				{
					key 		: 'analytic',
					text 		: 'analytic',
					placeholder : 'select',
					list 		: 'list_analytics',
					key_list	: 'name',
					text_list 	: 'name',
					type 		: 'select',
					visible 	: true,					
					multiple 	: false,  
					cols 		: {
						col : 1,
					},
				},
				// option ext
				{
					key  :  'plate_char',
					text :  'plate',
					type :  'text',
					visible 	 : false,					
					placeholder  : 'type a plate',
					ref_analytic : 'lpr',
					cols 		: {
						col : 1,
					},

				},
				{
					key 		: 'tags',
					text 		: 'tags',					
					list 		: 'list_objects',
					placeholder : 'select',
					ref_analytic : 'object',					
					/*key_list	: 'name',
					text_list 	: 'name',*/
					type 		: 'select',
					multiple 	: true,  
					visible 	: false,
					cols 		: {
						col : 1,
					},
				},
				{
					key 		: 'motion',
					text 		: 'motion',					
					list 		: 'list_motions',
					placeholder : 'select',
					ref_analytic : 'motion',					
					/*key_list	: 'name',
					text_list 	: 'name',*/
					type 		: 'select',
					multiple 	: true,  
					visible 	: false,
					cols 		: {
						col : 1,
					},
				},
				{
					key 		: 'anomalies',
					text 		: 'anomalies',					
					list 		: 'list_anomalies',
					placeholder : 'select',
					ref_analytic : 'anomalies',					
					/*key_list	: 'name',
					text_list 	: 'name',*/
					type 		: 'select',
					multiple 	: true,  
					visible 	: false,
					cols 		: {
						col : 1,
					},
				},
				{
					key  :  'entity',
					text :  'face',
					type :  'select_searcher',					
					list :  'list_entitys',
					placeholder : 'select',
					ref_analytic : 'face',					
					key_list	: 'name',
					text_list 	: 'name',
					type 		: 'select',
					key_search  : 'name',
					key_search_1 : 'id_tracker',
					multiple 	: true,  
					visible 	: false,
					cols 		: {
						col : 1,
					},
				},
				{
					key  :  'actions',
					text :  'actions',
					type :  'select',
					list : 'list_actions',
					placeholder : 'select',
					ref_analytic : 'actions',
					multiple 	: true,
					visible 	: false,
					cols 		: {
						col : 1,
					},
				},
				{
					key 		: 'btn',
					action 		: 'search',					
					ref 		: 'search',
					text 		: 'search',
					placeholder : 'btn',
					type 		: 'btn',
					color 		: 'primary',
					visible 	: true,
					cols 		: {
						col : 1,
					},
				},

			],
			list_devices 	: [],
			list_search 	: [],
			menu 		 	: false,
			dates 		 	: [], 	
			menu_picker 	: {
				start	: false, // menu
				end		: false,			
			},
			picker 			: {
				start	: "00:00", // 
				end		: "23:59",
			},

			show 		 	: true,
			ID_notification : 'playback',
			options 		: { itemsPerPage : 30 },
			total 			: 0,
			chartData 		: [
		        ['Time', 'Guns', 'Person', 'Pet', 'LPR'],//'Year', 'Sales', 'Expenses', 'Profit'
		        ['7:00 ', 100, 400, 10, 200 ],
		        ['10:00', 80, 460, 80, 300],
		        ['12:00', 30, 1120, 60, 222],
		        ['15:00', 25, 540, 100, 1234]
		      ],
		    
	     	size_height		: 100,
			size_width 		: 100,
			videoTimeline:[],
			indexPLay:0,
			video:{
				urlpath:""
			},
			url_video 		: vm.$URL,
			list_analytics 	: [ 
				'lpr', 
				'motion', 
				'object', 
				'face', 
				// 'gun', 
				// 'person', 
				'actions', 
				'anomalies'
			],
			list_analytics_tags : [ // for no have second option
				/*'lpr' ,
				'object' ,	
				'face'   ,				
				'actions',*/
				'anomalies', 
				'motion',
			],
			select_idx_analytic : null,
			datacollection : null,
			height : 100,
			pagination:{
				visible: 5,
				total: 0,			
				items: 0,
				found: true,
				
			},
			page: 1,
			offsetTop: 0,
			height_row : 370,
			slider_time : 1,
			sliders : {
				max : 200,
				min : 1
			},
			loading : false,
			message : {
				msg     : '',
				success : false,
				error   : false,
			},

			groups: [
			
                {
                    id:1,
                    content:'Objects',
                    subgroupStack: { sg_1: false, sg_2: false, sg_3: false },

                },
                {
                    id:2,
                    content:'Actions',
                    subgroupStack: { sg_1: false, sg_2: false, sg_3: false },

                }
			],
			items: [{
                    id: 0,
                    group: 0,
                    start: new Date(),
                    end:new Date(),
                    content: 'Item Init',
                    hidden:true
            }],
            itemss:[{
                src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg',
              },
              {
                src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg',
              },
              {
                src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg',
              },
              {
                src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg',
              }],
			options 	: {
				editable: false,
                
                horizontalScroll:true,
                verticalScroll:true,
                stack: false
			},
            src_img 	: vm.$logos.login_night,//'https://cdn.vuetifyjs.com/images/carousel/planet.jpg',
            tags_colors : [
        	  	{
            		tag   : 'person',
		          	color : 'background-color: #893AA4;',
            	},
            	{
            		tag   : 'car',
            		color : 'background-color: #82A43A;',
            	},

            	{
            		tag   : 'tvmonitor',
            		color : 'background-color: #090979;',
            	},
            	{
            		tag   : 'chair',
            		color : 'background-color: #008000;',
            	},
            	{
            		tag   : 'laptop',
            		color : 'background-color: #FFFF00;',
            	},
            	{
            		tag   : 'gun',
            		color : 'background-color: #FF0000;',
            	}
			          
            ],
            list_actions : [
				'Hands -up',
				'Walking',
				'Fighting',
				'Calling',
				'Falling',
				'Sitting',
				'Standing',						
			],
			list_objects : [
				'person',
				'gun',				
				'car'
										
			],
			list_entitys : [],
			list_anomalies : ['anomalies'],
			list_motions   : ['motion'],
		}), // data  

		created(){
			if (localStorage.getItem('list_devices')) {
				this.list_devices = JSON.parse(localStorage.getItem('list_devices'));
			}
			console.log(this.$momentz(), this.$momentz().format('L'))

			console.log(this.formatDate(this.$momentz().format('L')), "DATE FORMAT")
			// this.get_list()
			this.get_list_trained();
            let vm = this
            let idtest=3

          

            /*
            setInterval(()=>{

                vm.items.push({
                    id: idtest,
                    group: 0,
                    start: new Date(),
                    content: 'Item '+ idtest
                })
                idtest=idtest+1
            },5000)
            */


		}, // created

		watch:{

			options: {
				handler(){
					// this.get_list();

				}, deep: true, 
			}, // optitons

			page: function(val){
				// this.get_list();
			}, //page

			slider_time: function(current){
				if (current) {
					console.log("SLIDER : ", current, this.videoTimeline[this.indexPLay])
					if (this.videoTimeline[this.indexPLay]) {
						let video = this.videoTimeline[this.indexPLay];

						if (video && video.duration > 0 ) {
							video.element.currentTime = current;
						}
					}

				}
			}, // 

		}, // watch

		methods : {

			actions(act, item, opt){
				switch (act){
					case ('set_dates') : {
						// this.dates = item;
						this.menu = false;
					}break;
					case ('search') : {
						this.get_list(true)
					}break;
					default : {
						console.log("this option not exist ")
					}
				};
			}, // actions
			
			render_listed (list){
				return this[list];
			}, // render listed


			formatDate (date) {
		        if (!date) return null

		        const [year, month, day] = date.split('/')
		        return `${year}-${month}-${day}`
		    
		    }, // formatDate
			
			save_time(key, item, ref){
 				console.log("TIME *********************" , item, this.$refs[ref], key, ref)
 				this.$refs[ref][0].save(this.picker[key])
 				this.picker[key] = item;
 				// this.$refs[item].save(picker[item_search.key])
			},
			next_video(){
				this.indexPLay++
				this.video 		= this.videoTimeline[this.indexPLay]
				this.url_video  = '';
				const timer = setTimeout(()=>{

					this.url_video  = this.video && this.video.urlpath ? 
									this.$URL + this.video.urlpath : ''; 
					this.onResize();
					clearTimeout(timer)
				}, 500)
			},
			start_Playback(){
				this.indexPLay++
				if (this.videoTimeline[this.indexPLay]) {

					this.video 		= this.videoTimeline[this.indexPLay]
					this.url_video  = this.video && this.video.urlpath ? 
									 this.$URL + this.video.urlpath : '';

				}else{
					console.log("No have more index for playing", this.indexPLay);
					this.indexPLay --;
				}
				
			}, // start playback

			sel(video, index){
				console.log('charge video ', video, index);
				if (video && index >= 0) {
					// console.log("charge : ", index);
					this.video 		= this.videoTimeline[index];
					this.videoTimeline[this.indexPLay].active = false;
					this.videoTimeline[index].active = true;
					this.indexPLay = index;
					this.url_video  = '';
					const timer = setTimeout(()=>{

						this.url_video  = this.video && this.video.urlpath ? 
										this.$URL + this.video.urlpath : ''; 
						// console.log("charge video 1", video);
						// this.onResize();

						clearTimeout(timer)
					}, 500)
				}
			}, // sel

			onScroll (e) {
	    		this.offsetTop = e.target.scrollTop
	  		}, // onScroll

	  		onResize(val) {				
	  			console.log("Height : ****************** ", this.$refs.card.$el.clientHeight, this.$refs)
			 	if (this.$refs && this.$refs.card && this.$refs.card.$el && this.$refs.card.$el.clientHeight) {
			 		let rest = 	this.$refs.card.$el.clientHeight - 40; 
			 		if (this.$refs.video_play) {
			 			console.log(this.$refs.video_play.clientHeight )
			 			if (this.$refs.card.$el.clientHeight > this.$refs.video_play.clientHeight ) {
			 				rest = this.$refs.video_play.clientHeight + 10 ;
			 			}
			 			this.height = rest; // 145
			 		}

				}else{
					console.log("No found ref : card");
				}

			}, //on Resize

			set_time_lapse(){
				let list = this.videoTimeline;
				let vm   = this;
				vm.sliders.max = 1;
				if (list && list.length > 0) {
					let temp_video = [],
						cont = [];

					
					list.forEach((video, idx_video) => {
						temp_video[idx_video] = document.getElementById('video_event' + idx_video);
						if (temp_video[idx_video]) {
							 temp_video[idx_video].load();
							 cont[idx_video] = 1;
							const timer = setInterval(()=>{

									vm.videoTimeline[idx_video].element = temp_video[idx_video];
								
								if (temp_video[idx_video].readyState >= 2) {
								
									if (temp_video[idx_video].duration) {
										vm.videoTimeline[idx_video].duration = temp_video[idx_video].duration;
										vm.sliders.max += temp_video[idx_video].duration; 
									}
									clearInterval(timer);
								}				
								if (cont[idx_video] < 7) {
									cont[idx_video]++;
								}else{
									vm.videoTimeline[idx_video].ready = true;
									clearInterval(timer);
								}				
							}, 3000)
						}
					});
				}
			}, // set time lapse


			/*
				
			    {
					tag   : 
					color : 
					type  : 
			    }
			*/

			FormatJsonToTimeline(rows){
				let  vm = this

                console.log("response", rows)
				/*{
				id: 0,
				group: 0,
				start: new Date(),
				content: 'Item 1'
				}*/
            	let list_temp = rows.data;
                let temp_tag  = [];
                let tags 	  = [];
                vm.items = []
                vm.items = list_temp;
                // vm.tags_colors = [];

                
			    





                /*if (list_temp && list_temp.length > 0) {
                	list_temp.forEach((temp_item) => {
                		if (!temp_tag.includes(temp_item.title)) {
                			tags.push({
                				color : temp_item.style,
                				tag   : temp_item.title
                			})
                			temp_tag.push(temp_item.title);
                		}
                	}); // list temp
                	vm.tags_colors  = tags; 
                }else{

                	console.log("Not found objects")
                }*/


				/*if(rows.data.length>0){
					rows.data.forEach((ele,ind,arr)=>{
                        
                        const timer = setTimeout(function() {
                            if(vm.items.length==0){
                                //vm.items.push(ele) 
                            }
                            if(vm.items.some( its => its.id == ele.id)){
                                
                            }else{
                               // vm.items.push(ele)
                            }
                            clearTimeout(timer);
                        },ind*100)
                        
						
                       

						
							
						
						// if(ind==arr.length-1){
      //                      // console.log(vm.items,"items")
      //                     //  console.log(vm.$refs.timeline)
                            
						//     //vm.$refs.timeline.setItems(vm.items)
      //                       //vm.$refs.timeline.redraw()
						//     //vm.items=new DataSet(vm.objects)
						
						// }
					})
				}*/
				

			},

			get_data_axios(api,info_up, page = 0 , list = [], source=null){
				let  vm = this;
				// page++
				this.loading = true;
				let newapi 	 = api + "/?page=" + page;
				this.$axios.post(newapi, info_up).then( res => {
					if (res){
                        console.log("[response]",res.data.data)

						list = []; //res.data.rows; // list.concat(res.data.rows)
						if(source == 'object'){
                            vm.objects = res.data.data
							vm.FormatJsonToTimeline(res.data)
							console.log("Formated...", vm.objects)
							if (vm.objects && vm.objects.length > 0) {
								this.render_message(this.$ml.get('data_found'), 'success');
							}else{
		    					this.render_message(this.$ml.get('data_no_found'), 'error')  
		    					if (page == 1) {

			    					this.$EventBus.$emit("notifications_modal",{
										type    : 'warning',
										message : this.$ml.get('data_no_found')
									})     		
		    					}
							}

						}
		
						console.log(page,parseInt(res.data.pages),page<parseInt(res.data.pages))
						/*if(page == 1){
							// this.onResize();
							let temp_noti = list && list.length > 0 ? true : false;
							this.$EventBus.$emit("notifications_modal",{
								type    : temp_noti ? 'success' : 'warning',
								message : temp_noti ? this.$ml.get('data_found') :  this.$ml.get('data_no_found')
							})
						}
						if (list && list.length > 0) {
							vm.video = list[0]
							vm.url_video  = '';
							vm.videoTimeline = list;
							vm.indexPLay = 0;
							const timer = setTimeout(()=>{
								vm.url_video = vm.video && vm.video.urlpath ? 
								 'http://'+vm.$localhost+':'+ vm.$port+ vm.video.urlpath : '';
								// vm.onResize();
								vm.set_time_lapse();

							},50)

							let item 		= list.length;							
							let pages		= res.data && res.data.pages ? res.data.pages : '';
		      				
							this.pagination = {
		      					visible: 5,
								total: pages,			
								items: item,
								found: true,
		      				};
		      				
						}else{
		    				this.render_message(this.$ml.get('data_no_found'), 'error')    		

							// this.height = 300;
						}*/
					

					}
		    		this.loading = false;
		    	}).catch( er => {
		    		console.log(" Error Get list ", this.ID_notification + ' : ', er);
		    		this.loading = false;		
		    		this.render_message(this.$ml.get('data_no_found'), 'error') 
		    		this.$EventBus.$emit("notifications_modal",{
						type    : 'error',
						message : er
					});
		    	});

			},

		    
		    get_list(pag = false){
				this.videoTimeline 	= []
		    	let info_search 	= this.info_search;
		    	let info_up 		= null;
		    	let pg 				= this.page;
		    	let tags1  			= [];
		    	let entity1			= [];
		    	let plate 			= null;
		    	let timeZone 		= this.$timezone;
		    	// console.log("PICKER : ", this.picker, info_search, this.dates);
		    	if (info_search) {
		    		// render info to search
			    	
		    		if (this.info_search.dates && this.info_search.dates.length > 0) {
		    			this.dates = this.info_search.dates;
		    		}
		    		if (this.info_search.start) {
		    			this.picker.start = this.info_search.start;
		    		}
		    		if (this.info_search.end) {
		    			this.picker.end = this.info_search.end;
		    		}

		    		let formated_dates = this.$Format.format_date_time(this.dates, this.picker, true);
		    		if (formated_dates == 'required_range_24h') {
		    			this.$EventBus.$emit('notifications_modal',{
		    				type 	: 'warning',
		    				message : this.$ml.get('required_range_24h')
		    			})
		    			return false
		    		}
			    	let date1 = formated_dates.start,// this.$momentz(this.$momentz.now()).format('YYYY/MM/DD'), // L
			    		date2 = formated_dates.end;
		    		
					console.log("times : ", date1, date2);

					if (info_search.tags && info_search.tags.length > 0) {
						tags1 = info_search.tags;
					}
					if (info_search.anomalies && info_search.anomalies.length > 0) {
						tags1 = tags1.concat(info_search.anomalies);
					}
					if (info_search.motion && info_search.motion.length > 0) {
						tags1 = tags1.concat(info_search.motion);						
					}
					if (info_search.actions && info_search.actions.length > 0) {
						tags1 = tags1.concat(info_search.actions);
					}

					if (info_search.entity && info_search.entity.length > 0) {
						entity1 = info_search.entity;
					}
					if (info_search.plate_char) {
						plate = info_search.plate_char;
					}

					// set info to search
		    		info_up = {
		    			start 	 	:  date1, 
		    			end 	 	:  date2,		    			
		    			deviceId  	:  info_search.search, 
		    			tags 		:  tags1,
		    			entity 		:  entity1,
		    			plate_char  :  plate,
		    			timeZone,
		    		}		    		



			    	if (pag) {
			    		pg = 1;
			    	}
			    	console.log("request : ******************** ", info_up);
			    	const api 	= this.$URL + '/api/v1/records/find';
			    	const api1 	= this.$URL + '/api/v1/timeline/find';
					let objects =[]
			    	if (info_up.deviceId) {

						// this.get_data_axios(api, info_up, pg);
						this.get_data_axios(api1, info_up, pg,objects,"object");
						console.log(objects,"response")
			    	}else{
			    		console.log("Required : select device ");
			    		this.$EventBus.$emit('notifications_modal',{
			    			type 	: 'warning',
			    			message :  'Required : select device ',
			    		});
			    	}
		    	}else{
		    		console.log( "Not info to search ", info_search)
		    	}


		    
		    }, // get list	

		    async get_list_trained(){
				let page  = 1,
		          	pages = 2,
		          	list  = []; 

		        while (page < pages){

					const api = this.$URL_face + '/api/face/list?page=' + page;
					
					const listed =  await  
					this.$axios.get(api).then( res => {
						
						let items 	= res.data.results;
		            	if (res.data.next){
		                  pages++;              
		                }
						
						if (page == 1) {			                
			                list = items;
			            }else{
			                list = list.concat(items)
			            }

			            return list;
						
					}).catch( er =>{
						console.log(er, 'error get list trained')
					})
					page++;		        
		    	}
		       	
		       	if (list && list.length > 0) {     
		       		this.list_entitys = list; 
		       		// this.lists.list_entity = list;
		       	}

			}, // get_list_trained

		    render_message(msg, type){
		    	console.log("render message : ", msg, type)
		    	if (msg && type) {		    	
		    		this.message[type] 	= true;
		    		this.message.msg 	= msg; 
		    		const timer = setTimeout(()=>{
		    			this.message[type] = false;
		    			this.message.msg   = ''; 
		    			clearTimeout(timer);
		    		}, 2000)
	    		
		    	}

		    }, // render message

		 	render_analytic_option(key, item){

				console.log("key, item render option ", key, item);
		 		if (key == 'analytic') {
		 			let vm 				= this;
		 			let analytics 		= this.list_analytics; // this.list_analytics_tags; //
		 			let idx_analytic  	= null;
		 			if (!analytics.includes(item)) {
		 				idx_analytic = vm.info_search_fields.findIndex( x => x &&  x.ref_analytic == 'object' );
		 				/*let list_sel = 'list_' + item;
		 				if ( item != 'anomalies') {
		 					list_sel += 's';
		 				}
		 				vm.info_search_fields[idx_analytic].list = list_sel ;*/
		 			}else{
		 				idx_analytic = vm.info_search_fields.findIndex( x => x &&  x.ref_analytic == item );
		 			}
		 			console.log('idx_analytic', idx_analytic)
		 			if (idx_analytic >= 0) {
		 				if (vm.select_idx_analytic) {
		 					vm.info_search_fields[vm.select_idx_analytic].visible = false;
		 				}
		 				vm.select_idx_analytic  = idx_analytic;
		 				vm.info_search_fields[idx_analytic].visible = true;
		 			}
		 		}
		 	}, // render_analytic_option
    	
  
		}, // methods

		computed: {
			styles_charts: function(){
				return {
					height : `${this.height}'px'`,
					position : 'relative',
				}
			}, // styles charts 

		}, // computed

		mounted(){
            console.log(this.$refs)
            let vm = this
            if (this.$refs && this.$refs.timeline) {
            this.$refs.timeline.on('itemover',function (params) {
                console.log("data",params)

                vm.src_img = vm.$URL + vm.items.find( its =>{
                  
                    if(its.id == params.item){
                        console.log(vm.src_img,"image")
                        return its.evidence
                    }   
                }).evidence
                
            })
            this.$refs.timeline.on('rangechanged',function(data){
                console.log("changed",data)
                /*
                vm.items=vm.objects.filter(obj=>{
                    
                    let dateobj = vm.$momentz(obj.start)
                    let datetimeline_start=vm.$momentz(data.start)
                    let datetimeline_end=vm.$momentz(data.end)
                    console.log(`Date Timeline start: ${data.start} 
                                        > 
                    Date Query Start ${dateobj}`)
                    console.log(`Date Timeline End: ${data.end} 
                                        > 
                    Date Query End ${dateobj}`)
                    if(dateobj<datetimeline_end ){
                        console.log("mayor", data.start,"timeline", obj.start)
                        return true
                    }                     
                })
                */

                //vm.items=[]
            })
			} // if refs timeline
			// this.onResize();
			
		}, // mounted
	};